// extracted by mini-css-extract-plugin
export default {"body":"MainLayout_body__Vn92U"};